/* eslint-disable no-throw-literal */
import { ResponseResult, post } from '@shared/tandon-plugin/request';
import { CreateIncidentReq, CreateIncidentRsp } from '../type';

/**
 * 创建事件单
 */
export const createIncident = (params: CreateIncidentReq): Promise<ResponseResult<CreateIncidentRsp>> => post('/api/v1/incident/CreateIncident', params);
